import GetInvoiceMerchants from "../symbols/getInvoiceMerchants";
export interface InvoiceMerchant{
  Id:string;
  Name:string;
}
interface IState {
  data: InvoiceMerchant[];
  loading: boolean;
  error: boolean;
}
const initialState: IState = {
  data: [],
  loading: false,
  error: false,
};

export default function GetInvoiceMerchantsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case GetInvoiceMerchants.GET_INVOICE_MERCHANTS:
      return { ...state, loading: true, error: false };
    case GetInvoiceMerchants.GET_INVOICE_MERCHANTS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result as InvoiceMerchant[],
        loading: false,
        error: false,
      };
    case GetInvoiceMerchants.GET_INVOICE_MERCHANTS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GetInvoiceMerchants.CLEAR_GET_INVOICE_MERCHANTS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
